<template>
  <div id="action-list" class="flex justify-center">
    <div
      class="hidden p-0 lg:grid lg:grid-cols-2 lg:p-0 justify-center max-w-7xl bg-white pointer-events-auto"
      @mouseenter="
        setCursor($t('cant-miss-it'), cursorAction, {
          'font-size': '14px',
          width: '100px',
          height: '100px',
        })
      "
    >
      <div v-if="title" class="action-list-container lg:mr-16 py-6">
        <div class="action-list-date">{{ formatDate }}</div>
        <div>
          <h3 class="font-light">{{ title }}</h3>
        </div>
        <div v-if="formattedPerex" class="mb-12">
          <div v-html="formattedPerex"></div>
        </div>
      </div>
      <div class="overflow-hidden">
        <img
          class="h-full object-cover lg:min-w-full mt-4 lg:mt-0 md:w-full featured-article-img"
          :src="featuredImage"
        />
      </div>
    </div>

    <div class="block lg:hidden py-2 mb-20 w-full">
      <div class="overflow-hidden">
        <img class="lg:min-w-full md:w-full" :src="featuredImage" />
      </div>
      <div v-if="title" class="border-b border-black mx-6">
        <div class="action-list-date !mt-6 !mb-6">{{ formatDate }}</div>
        <div>
          <h2 class="font-light mb-10">{{ title }}</h2>
        </div>
        <div class="mb-6"><div v-html="formattedPerex"></div></div>
        <button
          class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm mb-9"
          @click="cursorAction"
        >
          {{ $t("Read") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

const props = defineProps({
  featuredItem: Object,
  setCursor: Function,
});

const { featuredItem } = props;
const { perex, title, featuredImage, date, slug } = featuredItem;
const localePath = useLocalePath();
const formattedPerex = ref("");

function replaceBlockquotesAndRemoveStyles(htmlContent) {
  // Create a DOM parser to parse the HTML content
  if (!htmlContent) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  // Remove styles from all elements
  const allElements = doc.querySelectorAll("*");
  allElements.forEach((element) => {
    element.removeAttribute("style");
  });

  // Find all blockquote elements
  const blockquotes = doc.querySelectorAll("blockquote");

  // Replace each blockquote element with the custom div structure
  blockquotes.forEach((blockquote) => {
    // Extract text content
    const quoteText = blockquote.innerText.trim();

    // Create the new element with the desired format
    // Replace the blockquote with the new element
    blockquote.outerHTML = `
                    <div class="quote">
                        <div class="quote-sign">“</div>
                        <div class="quote__text mb-12">
                            ${quoteText}
                        </div>
                        <div class="quote-sign">“</div>
                    </div>
                `;
  });

  const pres = doc.querySelectorAll("pre");
  pres.forEach((pre) => {
    const content = pre.innerHTML;
    pre.outerHTML = content;
  });

  // Serialize the document back to a string and return it
  return doc.documentElement.innerHTML;
}

onMounted(() => {
  formattedPerex.value = replaceBlockquotesAndRemoveStyles(perex);
});

const dateRaw = new Date(date);

const formatDate =
  ("0" + dateRaw.getDate()).slice(-2) +
  "." +
  ("0" + (dateRaw.getMonth() + 1)).slice(-2) +
  "." +
  dateRaw.getFullYear();

const cursorAction = () => {
  return navigateTo(localePath({ name: "article-id", params: { id: slug } }));
};

// TODO
// const { title, eventsConfig, uri } = featuredItem[0]
// const { datesettings, perex, featuredImage } = eventsConfig;
// const { date, timeFrom, timeEnd } = datesettings
// const { sourceUrl } = featuredImage
//
// const {title, date, perex, sourceUrl} = props
</script>

<style scoped>
.action-list-date {
  font-family: Roboto;
  font-weight: 600;
  font-size: 16px;

  margin-top: 32px;
  margin-bottom: 24px;
}

.action-list-container {
  border-top: #000 1px solid;
  border-bottom: #000 1px solid;

  @media screen and (max-width: 1024px) {
    border-top: none;
  }
}

h3 {
  margin-bottom: 32px;
}

h2 {
  line-height: normal;
}

.featured-article-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  max-height: 400px;
}
</style>
